import { OrdersList as OrdersListComponent } from 'components/orders/OrdersList/OrdersList'

export const OrdersList: React.FC = () => {
  return <OrdersListComponent />
}